import { FloatingMenu } from "./FloatingMenu";
export default FloatingMenu;
